<div *ngIf="!!topic || inserting; else loading;">
  <div id="topic-detail-component">
    <div *ngIf="editable; else readonly" class="editable">
      <div class="bigfield">
        <input [(ngModel)]="topic.topic" placeholder="Enter a topic for discussion..." title="A topic for discussion."
          class="h2" style="width: 30em" />
      </div>
      <div class="field">
        <label>short name: </label>
        <input [(ngModel)]="topic.short_name" class="longer_input" placeholder="partial_file_name"
          title="A short identifying name to be used as part of the filename." />
      </div>
      <div class="field">
        <label>min duration: </label>
        <input [(ngModel)]="topic.min_duration" type="number" placeholder="5"
          title="The minimum number of seconds for a valid response." />
        seconds
      </div>
      <div class="field">
        <label>max duration: </label>
        <input [(ngModel)]="topic.max_duration" type="number" placeholder="{{topic.max_duration}}"
          title="The maximum number of seconds of audio for responses." />
        seconds
      </div>
      <div class="field">
        <label>author: </label>
        <input [(ngModel)]="topic.author" class="longer_input" placeholder="Author Name"
          title="The publicly acknowledged author of this topic." />
      </div>
      <div class="mat-field">
        <label>station: </label>
        <span *ngIf="programmes.length > 1; else only_one" class="programme_select">
          <select #topic_programme required [(ngModel)]="topic.programme_id" name="programme_id">
            <option *ngFor="let programme of programmes" [ngValue]="programme.id"> {{programme.name}} </option>
          </select>
        </span>
        <ng-template #only_one>
          {{programmes[0].name}}
        </ng-template>
      </div>
      <div class="bigfield">
        <label>active: </label>
        <checkbox [(ngModel)]="topic.active"></checkbox><span> &nbsp; </span>
        <div *ngIf="CanAdminister()" class="panel">
          <button (click)="save()" class="btn btn-primary">Save</button>
        </div>
      </div>

      <div *ngIf="CanAdminister() && !inserting">
        <img src="/images/cancel.svg" (click)="cancel()" class="editlink">
      </div>
    </div>
    <ng-template #readonly>
      <div class="editable">
        <div class="bigfield"><span class="h2">{{topic.topic}}</span></div>
        <div class="field"><label>short name: </label>{{topic.short_name}}</div>
        <div class="field"><label>min duration: </label>{{topic.min_duration}}</div>
        <div class="field"><label>max duration: </label>{{topic.max_duration}}</div>
        <div class="field"><label>author: </label>{{topic.author}}</div>
        <div class="field"><label>programme: </label> {{topic.programme_id}} - {{topic.programme_name}} </div>
        <div class="field"><label>active: </label>{{topic.active}}</div>
        <div *ngIf="CanAdminister()">
          <img src="/images/edit.svg" (click)="edit()" class="editlink">
        </div>
      </div>
    </ng-template>
  </div>

  <div *ngIf="topic.response_count > 0">
    <br />
    <h2>{{topic.response_count}} responses</h2>
  </div>
</div>
<ng-template #loading>
  Loading...
</ng-template>